import React from 'react';
import './styles.css';

export default function Spinner({ style }) {
  return (
    <div className="spinner" style={style} />
  );
}



// WEBPACK FOOTER //
// ./src/components/spinner/index.jsx